import { ReactNode } from "react";
import { HTMLLevels } from "~/components/Heading";
import { SectionHeading } from "~/components/SectionHeading";

function SingleType({ children }: { children: ReactNode }) {
  return <>{children}</>;
}

function SingleTypeHeading({ children }: { children: ReactNode }) {
  return (
    <SectionHeading>
      <SectionHeading.Title level={HTMLLevels.h1} className="mb-28">
        {children}
      </SectionHeading.Title>
    </SectionHeading>
  );
}

function SingleTypeContent({ children }: { children: ReactNode }) {
  return <div className="lg:mx-28 xl:mx-48 mb-28">{children}</div>;
}

SingleType.Heading = SingleTypeHeading;
SingleType.Content = SingleTypeContent;

export default SingleType;
